import React from 'react';
import { motion } from 'framer-motion';
export function AboutCoach() {
  return <section className="py-20 md:py-28 bg-sep-offwhite" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-15">
            <div className="aspect-[3/4] md:aspect-[4/5] rounded-lg overflow-hidden shadow-2xl relative z-10" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/qfhcfQiGshWXmk3fDrkBcw/slater-elite-performace-about.png" alt="Coach Slater" className="w-full h-full object-cover object-center" data-id="element-17" />
            </div>
            {/* Background decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-full h-full bg-sep-red rounded-lg -z-0 hidden md:block" data-id="element-18"></div>
            <div className="absolute top-1/2 -right-12 w-24 h-24 border-8 border-sep-charcoal/5 rounded-full -z-0 hidden lg:block" data-id="element-19"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-20">
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-sep-charcoal uppercase mb-8" data-id="element-21">
              MEET COACH SLATER
            </h2>

            <div className="space-y-6 text-gray-700 text-base md:text-lg mb-10" data-id="element-22">
              <p data-id="element-23">
                Owner and founder of S.E.P., Coach Slater brings years of
                experience coaching basketball and leading youth athletes to
                championships.
              </p>
              <p data-id="element-24">
                As a NASM Certified Personal Trainer currently pursuing a Sports
                Science degree at ASU, Coach Slater is on the path to becoming a
                licensed physical therapist. This deep understanding of
                biomechanics and physiology informs every training session.
              </p>
              <p data-id="element-25">
                Coach Slater specializes in working with athletes of all
                abilities, including neurodiverse athletes (Autism, ADHD),
                ensuring that every individual has the opportunity to develop
                their skills, build confidence, and reach their full potential.
              </p>
            </div>

            <div className="bg-white p-6 md:p-8 rounded-lg shadow-md border-l-4 border-sep-red relative" data-id="element-26">
              <svg className="absolute top-4 left-4 w-8 h-8 text-sep-red/20" fill="currentColor" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" data-id="element-27">
                <path d="M10 8c-3.3 0-6 2.7-6 6v10h10V14H8c0-1.1.9-2 2-2h2V8zm14 0c-3.3 0-6 2.7-6 6v10h10V14h-6c0-1.1.9-2 2-2h2V8z" data-id="element-28" />
              </svg>
              <p className="font-heading font-bold text-xl md:text-2xl text-sep-charcoal italic relative z-10 pl-6" data-id="element-29">
                "Purpose, passion, and proven results — every session."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}